import { FunctionalComponent } from 'preact'
import Add from './icon-add'
import AddWidget from './icon-add-widget'
import Answer from './icon-content-type-answer'
import ArrowDown from './icon-arrow-down'
import ArrowDropdown from './icon-arrow-drop-down'
import ArrowDropUp from './icon-arrow-drop-up'
import ArrowRight from './icon-arrow-right'
import ArrowUp from './icon-arrow-up'
import Article from './icon-content-type-article'
import Calendar from './icon-calendar'
import ChangeAuthor from './icon-change-author'
import Checkbox from './icon-checkbox'
import Checkmark from './icon-checkmark'
import ChevronDown from './icon-chevron-down'
import ChevronLeft from './icon-chevron-left'
import ChevronRight from './icon-chevron-right'
import ChevronUp from './icon-chevron-up'
import CirclePlus from './icon-outlined-circle-plus'
import Clock from './icon-clock'
import Close from './icon-close'
import Code from './icon-code'
import Computer from './icon-computer'
import Discussion from './icon-content-type-discussion'
import Edit from './icon-edit'
import Email from './icon-email'
import ExternalLink from './icon-external-link'
import Eye from './icon-eye'
import EyeCross from './icon-eye-cross'
import Filter from './icon-filter'
import Forbidden from './icon-forbidden'
import Idea from './icon-content-type-idea'
import Info from './icon-info'
import InsertPoll from './icon-insert-poll'
import Loader from './loader'
import Location from './icon-location'
import Link from './icon-link'
import Lock from './icon-lock'
import MoreHoriz from './icon-more-horiz'
import Palette from './icon-palette'
import People from './icon-people'
import Platform from './icon-platform'
import Puzzle from './icon-puzzle'
import Question from './icon-content-type-question'
import Search from './icon-search'
import Setting from './icon-setting'
import Sort from './icon-sort'
import Trash from './icon-trash'
import Triangle from './icon-triangle'
import FileOutline from './icon-outlined-file'
import File from './icon-file'
import Users from './icon-outlined-users'
import Piechart from './icon-outlined-piechart'
import Grid from './icon-outlined-grid'
import Pen from './icon-outlined-pen'
import Integrations from './icon-outlined-integrations'
import Game from './icon-outlined-game'
import Settings from './icon-outlined-settings'
import UserPlus from './icon-outlined-user-plus'
import OpenInNew from './icon-outlined-open-in-new'
import Mail from './icon-outlined-mail'
import ArrowRoundedLeft from './icon-arrow-rounded-left'
import LogOut from './icon-log-out'
import SquareDiagonalArrow from './icon-square-diagonal-arrow'
import ArrowBack from './icon-arrow-back'
import SpeachBubble from './icon-speach-bubble'
import Locked from './icon-locked'
import ClockDestination from './icon-destination-clock'
import Team from './icon-team'
import Pin from './icon-pin'
import Share from './icon-share'
import StickyFlag from './icon-sticky-flag'
import ProductUpdateType from './icon-product-update-type'
import Refresh from './icon-refresh'
import Like from './icon-like'
import CheckUserRegistration from './icon-outline-check-user-registration'
import UsernameRestrictions from './icon-outline-username-restrictions'
import KeywordBlocker from './icon-outline-keyword-blocker'
import NoReply from './icon-outline-no-reply'
import ModeratorApproval from './icon-outline-moderator-approval'
import Star from './icon-star'
import StarBorder from './icon-star-border'
import Warning from './icon-warning'
import Help from './icon-help'
import DownloadCloud from './icon-download-cloud'
import Upload from './icon-upload'
import Download from './icon-download'
import Key from './icon-key'
import Column from './icon-column'
import Reply from './icon-reply'
import Cancel from './icon-cancel'
import Check from './icon-check'
import Tag from './icon-tag'
import User from './icon-user'
import UserRole from './icon-user-role'
import Move from './icon-move'
import AddUser from './icon-add-user'
import Message from './icon-outlined-message'
import Editor from './icon-outlined-editor'
import Variable from './icon-variable'
import Menu from './icon-menu'
import Person from './icon-person'
import Spinner from './icon-spinner'
import Medal from './icon-medal'
import OutlineSuggestedCircleCheck from './icon-outline-suggested-circle-check'
import Send from './icon-outline-send'
import UsersPlus from './icon-outlined-users-plus'
import AnimatedLoader from './animated-loader'
import SolvedQuestion from './icon-solved-question'
import ByZapier from './icon-by-zapier'
import Zapier from './icon-zapier'
import LoadingSpinner from './icon-loading-spinner'
import Sync from './icon-sync'
import World from './icon-world'
import Upgrade from './icon-upgrade'
import FlaggedContent from './icon-flagged-content'
import Customisation from './icon-customisation'
import OneOffEmail from './icon-one-off-email'
import AutomatedEmail from './icon-automated-email'
import Topics from './icon-outline-topic'
import Description from './icon-outline-description'
import Copy from './icon-copy'
import Read from './icon-read'
import NavigationAnalytics from './icon-navigation-analytics'
import NavigationContent from './icon-navigation-content'
import NavigationCreate from './icon-navigation-create'
import NavigationCustomisation from './icon-navigation-customisation'
import NavigationEmail from './icon-navigation-email'
import NavigationGamification from './icon-navigation-gamification'
import NavigationIntegrations from './icon-navigation-integrations'
import NavigationPlatform from './icon-navigation-platform'
import NavigationSettings from './icon-navigation-settings'
import NavigationUsers from './icon-navigation-users'
import NavigationMessage from './icon-navigation-message'
import Restore from './icon-restore'
import NavigationTeam from './icon-navigation-team'
import NavigationDigitalHub from './icon-navigation-digital-hub'
import NavigationLogout from './icon-navigation-logout'

type cssValue = string | number | undefined

export const icons = {
  code: Code,
  copy: Copy,
  chevronDown: ChevronDown,
  changeAuthor: ChangeAuthor,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  clock: Clock,
  close: Close,
  article: Article,
  answer: Answer,
  discussion: Discussion,
  conversation: Discussion,
  question: Question,
  idea: Idea,
  ideation: Idea,
  edit: Edit,
  email: Email,
  externalLink: ExternalLink,
  flaggedContent: FlaggedContent,
  insertPoll: InsertPoll,
  moreHoriz: MoreHoriz,
  palette: Palette,
  people: People,
  platform: Platform,
  setting: Setting,
  loader: Loader,
  location: Location,
  link: Link,
  arrowDropdown: ArrowDropdown,
  arrowDropUp: ArrowDropUp,
  arrowRight: ArrowRight,
  lock: Lock,
  sort: Sort,
  search: Search,
  add: Add,
  eye: Eye,
  'eye-cross': EyeCross,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  trash: Trash,
  triangle: Triangle,
  addWidget: AddWidget,
  checkbox: Checkbox,
  puzzle: Puzzle,
  filter: Filter,
  info: Info,
  calendar: Calendar,
  checkmark: Checkmark,
  forbidden: Forbidden,
  circlePlus: CirclePlus,
  fileOutline: FileOutline,
  file: File,
  users: Users,
  usersPlus: UsersPlus,
  piechart: Piechart,
  grid: Grid,
  pen: Pen,
  integrations: Integrations,
  game: Game,
  settings: Settings,
  userPlus: UserPlus,
  openInNew: OpenInNew,
  mail: Mail,
  arrowRoundedLeft: ArrowRoundedLeft,
  logOut: LogOut,
  squareDiagonalArrow: SquareDiagonalArrow,
  arrowBack: ArrowBack,
  locked: Locked,
  clockDestination: ClockDestination,
  'speach-bubble': SpeachBubble,
  team: Team,
  pin: Pin,
  computer: Computer,
  share: Share,
  stickyFlag: StickyFlag,
  productUpdate: ProductUpdateType,
  refresh: Refresh,
  like: Like,
  checkUserRegistration: CheckUserRegistration,
  usernameRestrictions: UsernameRestrictions,
  keywordBlocker: KeywordBlocker,
  noReply: NoReply,
  moderatorApproval: ModeratorApproval,
  star: Star,
  starBorder: StarBorder,
  warning: Warning,
  help: Help,
  downloadCloud: DownloadCloud,
  upload: Upload,
  download: Download,
  key: Key,
  column: Column,
  reply: Reply,
  cancel: Cancel,
  check: Check,
  tag: Tag,
  user: User,
  move: Move,
  addUser: AddUser,
  message: Message,
  editor: Editor,
  variable: Variable,
  menu: Menu,
  person: Person,
  spinner: Spinner,
  medal: Medal,
  suggestedCircleCheck: OutlineSuggestedCircleCheck,
  send: Send,
  animatedLoader: AnimatedLoader,
  solvedQuestion: SolvedQuestion,
  byZapier: ByZapier,
  zapier: Zapier,
  loadingSpinner: LoadingSpinner,
  sync: Sync,
  world: World,
  upgrade: Upgrade,
  customisation: Customisation,
  oneOffEmail: OneOffEmail,
  automatedEmail: AutomatedEmail,
  userRole: UserRole,
  topics: Topics,
  description: Description,
  restore: Restore,
  read: Read,
  navigationAnalytics: NavigationAnalytics,
  navigationContent: NavigationContent,
  navigationCreate: NavigationCreate,
  navigationCustomisation: NavigationCustomisation,
  navigationEmail: NavigationEmail,
  navigationGamification: NavigationGamification,
  navigationIntegrations: NavigationIntegrations,
  navigationPlatform: NavigationPlatform,
  navigationSettings: NavigationSettings,
  navigationUsers: NavigationUsers,
  navigationMessage: NavigationMessage,
  navigationTeam: NavigationTeam,
  navigationDigitalHub: NavigationDigitalHub,
  navigationLogout: NavigationLogout,
}

export type IconType = keyof typeof icons

export interface IconProps {
  icon: IconType
  height?: cssValue
  width?: cssValue
  size?: cssValue
  customClass?: string
  onClick?: OnClickCallback
  color?: string
}

export interface IconComponentProps {
  height: cssValue
  width: cssValue
  customClass?: string
  onClick?: OnClickCallback
  color?: string
}

export type IconComponentInterface = FunctionalComponent<IconComponentProps>

const Icon = ({
  icon,
  height = undefined,
  width = undefined,
  size = undefined,
  customClass = '',
  onClick = undefined,
  color
}: IconProps) => {
  /**
   * The type of height or width is derived as numbers from .js files
   * Although, every icon will support string values like 1em,
   * we need to use as keyword here.
   * When we migrate icons to TS it won't be needed
   */
  const IconComponent = icons[icon] as IconComponentInterface
  return (
    <IconComponent
      height={height ?? size}
      width={width ?? size}
      customClass={customClass}
      onClick={onClick}
      color={color}
    />
  )
}

export default Icon
